import { DeliveryTrackingDto } from './dtos/tracking';
import { sagwClient } from './clients';
import { dtoToCaptainDetails } from './transformers/tracking';

export function fetchDeliveryTracking(deliveryId: string) {
  return sagwClient.get<DeliveryTrackingDto>(`/mot/user/deliveries/${deliveryId}/tracking`);
}

export function fetchDeliveryTrackingDriverDetails(deliveryId: string) {
  return fetchDeliveryTracking(deliveryId).then(dtoToCaptainDetails);
}
